// src/models/AddMedicine.jsx
import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import AppConst from "../apis/appconst";
import axios from "axios";
import Swal from "sweetalert2";

const AddMedicine = ({ item, onAddDepart }) => {
  const [formData, setFormData] = useState({
    cats: [],
    units: [],
    med_id: "",
    med_name: "",
    med_sel_category: "",
    med_select_unit: "",
    med_pkg_number: "",
    med_hsn_code: "",
    med_central_tax: "",
    med_state_tax: "",
    med_comp_name: "",
    med_composition: "",
    med_in_strips: "1",
    med_user: "",
  });

  const [ldata, setLdata] = useState(null);

  const toCatOptions = (records = []) =>
    records.map((r) => ({ value: String(r.cat_id), label: r.cat_name }));
  const toUnitOptions = (records = []) =>
    records.map((r) => ({
      value: String(r.unit_id ?? r.cat_id ?? r.id ?? ""),
      label: r.unit_name ?? r.cat_name ?? r.name ?? "",
    }));

  // ---------- API calls ----------
  const loadUnits = async (userId = 1) => {
    try {
      const fd = new FormData();
      fd.append("page_no", "none");
      // ✅ Remove user filter - fetch all units for all users
      // fd.append("par_by", userId);
      const resp = await axios.post(AppConst.BASE_URL + "/Webapis/get_unit_list", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (resp && resp.data && resp.data.status) {
        const recs = Array.isArray(resp.data.records) ? resp.data.records : [];
        const opts = toUnitOptions(recs);
        setFormData((prev) => ({ ...prev, units: opts }));
        return opts;
      } else {
        setFormData((prev) => ({ ...prev, units: [] }));
        return [];
      }
    } catch (err) {
      console.error("loadUnits error:", err);
      setFormData((prev) => ({ ...prev, units: [] }));
      return [];
    }
  };

  const loadCats = async (userId = 1) => {
    try {
      const fd = new FormData();
      fd.append("cat_type", "medcats");
      fd.append("page_no", "none");
      fd.append("search_key", "");
      fd.append("par_by", userId + "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data && response.data.status) {
        const opts = toCatOptions(response.data.records || []);
        setFormData((prev) => ({ ...prev, cats: opts }));
        return opts;
      } else {
        setFormData((prev) => ({ ...prev, cats: [] }));
        return [];
      }
    } catch (err) {
      console.error("loadCats error:", err);
      setFormData((prev) => ({ ...prev, cats: [] }));
      return [];
    }
  };

  const createCategoryApi = async (name) => {
    const fd = new FormData();
    fd.append("cat_name", name);
    fd.append("cat_type", "medcats");
    fd.append("par_by", ldata?.user_id || 1);
    const resp = await axios.post(AppConst.BASE_URL + AppConst.addCatUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp?.data;
  };
  const createUnitApi = async (name) => {
    const fd = new FormData();
    fd.append("unit_name", name);
    fd.append("par_by", ldata?.user_id || 1);
    const resp = await axios.post(AppConst.BASE_URL + AppConst.addunitmed, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp?.data;
  };

  // ---------- init ----------
  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    const parsed = JSON.parse(storedData);
    setLdata(parsed);
    const uid = parsed?.user_id || 1;
    // ✅ Load units without user filter, categories with user filter
    await Promise.all([loadCats(uid), loadUnits()]);
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) setLdata(JSON.parse(storedData));
    initData();

    if (item) {
      setFormData((prev) => ({
        ...prev,
        med_id: item.med_id || "",
        med_name: item.med_name || "",
        med_sel_category: item.med_sel_category ? String(item.med_sel_category) : "",
        med_select_unit: item.med_select_unit ? String(item.med_select_unit) : "",
        med_pkg_number: item.med_pkg_number || "",
        med_hsn_code: item.med_hsn_code || "",
        med_central_tax: item.med_central_tax || "",
        med_state_tax: item.med_state_tax || "",
        med_comp_name: item.med_comp_name || "",
        med_composition: item.med_composition || "",
        med_in_strips: item.med_in_strips || "1",
        med_user: item.med_user || "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        med_id: "",
        med_name: "",
        med_sel_category: "",
        med_select_unit: "",
        med_pkg_number: "",
        med_hsn_code: "",
        med_central_tax: "",
        med_state_tax: "",
        med_comp_name: "",
        med_composition: "",
        med_in_strips: "1",
        med_user: "",
      }));
    }
    // eslint-disable-next-line
  }, [item]);

  // ---------- helpers ----------
  const hideBootstrapModal = () => {
    const el = document.getElementById("showModal");
    if (!el) return false;
    el.classList.add("bs-modal-temporary-hidden");
    document.body.classList.remove("modal-open");
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.style.display = "none";
    return true;
  };
  const restoreBootstrapModal = () => {
    const el = document.getElementById("showModal");
    if (!el) return;
    el.classList.remove("bs-modal-temporary-hidden");
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.style.display = "";
  };

  // ---------- change handlers ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    const central = parseFloat(name === "med_central_tax" ? value : formData.med_central_tax) || 0;
    const state = parseFloat(name === "med_state_tax" ? value : formData.med_state_tax) || 0;
    updated.med_comp_name = (central + state).toString();
    setFormData(updated);
  };

  const handleSelectCategory = (option) => {
    setFormData((prev) => ({ ...prev, med_sel_category: option ? option.value : "" }));
  };
  const handleSelectUnit = (option) => {
    setFormData((prev) => ({ ...prev, med_select_unit: option ? option.value : "" }));
  };

  // ---------- creatable handlers ----------
  const onCreateCategory = async (inputValue) => {
    if (!inputValue || !String(inputValue).trim()) return;
    try {
      const res = await createCategoryApi(inputValue.trim());
      if (res && res.status) {
        if (res.cat_dt) {
          const dt = Array.isArray(res.cat_dt) ? (res.cat_dt[0] || res.cat_dt) : res.cat_dt;
          const newOpt = { value: String(dt.cat_id), label: dt.cat_name };
          setFormData((prev) => ({ ...prev, cats: [...prev.cats, newOpt], med_sel_category: newOpt.value }));
        } else {
          const opts = await loadCats(ldata?.user_id || 1);
          const found = opts.find((o) => o.label.toLowerCase() === inputValue.toLowerCase());
          if (found) setFormData((prev) => ({ ...prev, med_sel_category: found.value }));
        }
        Swal.fire({ icon: "success", title: "Category added", timer: 900, showConfirmButton: false });
      } else {
        Swal.fire({ icon: "error", title: "Failed", text: res?.success || "Server error" });
      }
    } catch (err) {
      console.error("onCreateCategory error:", err);
      Swal.fire({ icon: "error", title: "Failed", text: String(err?.message || err) });
    }
  };

  const onCreateUnit = async (inputValue) => {
    if (!inputValue || !String(inputValue).trim()) return;
    try {
      const res = await createUnitApi(inputValue.trim());
      if (res && res.status) {
        const u = res.unit;
        if (u && (u.unit_id || u.unitId || u.id)) {
          const newOpt = { value: String(u.unit_id ?? u.unitId ?? u.id), label: u.unit_name ?? inputValue };
          setFormData((prev) => ({ ...prev, units: [...prev.units, newOpt], med_select_unit: newOpt.value }));
        } else {
          // ✅ Reload all units without user filter
          const opts = await loadUnits();
          const found = opts.find((o) => o.label.toLowerCase() === inputValue.toLowerCase());
          if (found) setFormData((prev) => ({ ...prev, med_select_unit: found.value }));
        }
        Swal.fire({ icon: "success", title: "Unit added", timer: 900, showConfirmButton: false });
      } else {
        Swal.fire({ icon: "error", title: "Failed", text: res?.success || "Server error" });
      }
    } catch (err) {
      console.error("onCreateUnit error:", err);
      Swal.fire({ icon: "error", title: "Failed", text: String(err?.message || err) });
    }
  };

  // ---------- + button prompts (use hide/restore to avoid focus trap) ----------
  const promptAddCategory = async () => {
    const hid = hideBootstrapModal();
    try {
      const { value: catName } = await Swal.fire({
        title: "Add new category",
        input: "text",
        inputPlaceholder: "Category name",
        showCancelButton: true,
        confirmButtonText: "Add",
        target: document.body,
        customClass: { popup: "swal2-high-zindex" },
        didOpen: () => {
          const input = Swal.getInput();
          if (input) { input.focus(); if (input.select) input.select(); }
        },
        preConfirm: (v) => {
          if (!v || !String(v).trim()) {
            Swal.showValidationMessage("Category name is required");
          }
          return v && String(v).trim();
        },
      });
      if (catName) await onCreateCategory(catName);
    } finally {
      if (hid) restoreBootstrapModal();
    }
  };

  const promptAddUnit = async () => {
    const hid = hideBootstrapModal();
    try {
      const { value: unitName } = await Swal.fire({
        title: "Add new unit",
        input: "text",
        inputPlaceholder: "Unit name (e.g., strip, bottle, tablet)",
        showCancelButton: true,
        confirmButtonText: "Add",
        target: document.body,
        customClass: { popup: "swal2-high-zindex" },
        didOpen: () => {
          const input = Swal.getInput();
          if (input) { input.focus(); if (input.select) input.select(); }
        },
        preConfirm: (v) => {
          if (!v || !String(v).trim()) {
            Swal.showValidationMessage("Unit name is required");
          }
          return v && String(v).trim();
        },
      });
      if (unitName) await onCreateUnit(unitName);
    } finally {
      if (hid) restoreBootstrapModal();
    }
  };

  // ---------- submit ----------
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("med_id", formData.med_id);
    fd.append("med_name", formData.med_name);
    fd.append("med_sel_category", formData.med_sel_category);
    fd.append("med_select_unit", formData.med_select_unit);
    fd.append("med_pkg_number", formData.med_pkg_number);
    fd.append("med_hsn_code", formData.med_hsn_code);
    fd.append("med_central_tax", formData.med_central_tax);
    fd.append("med_state_tax", formData.med_state_tax);
    fd.append("med_comp_name", formData.med_comp_name);
    fd.append("med_composition", formData.med_composition);
    fd.append("med_in_strips", formData.med_in_strips);
    fd.append("med_user", ldata?.user_id || 1);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addMedUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status) {
        const closeBtn = document.getElementById("closeBt45");
        if (closeBtn) closeBtn.click();
        onAddDepart && onAddDepart();
        Swal.fire({ icon: "success", title: "Saved", timer: 1200, showConfirmButton: false });
      } else {
        Swal.fire({ icon: "error", title: "Failed", text: response.data.success || "Server error" });
      }
    } catch (err) {
      console.error("submit med error", err);
      Swal.fire({ icon: "error", title: "Save failed", text: String(err?.message || err) });
    }
  };

  // react-select styles + portal config
  const rsStyles = {
    control: (base) => ({ ...base, minHeight: "38px", borderRadius: "4px" }),
    menu: (base) => ({ ...base, zIndex: 99999 }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  };

  const findOption = (options, val) => options.find((o) => String(o.value) === String(val)) || null;

  return (
    <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">&nbsp;</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
          </div>

          <form className="tablelist-form" onSubmit={handleSubmit}>
            <div className="modal-body">
              <input id="id-field" type="hidden" />
              <div className="row gy-4 mb-3">
                <div className="col-md-4">
                  <label className="form-label">Medicine Name</label>
                  <input name="med_name" onChange={(e) => setFormData(prev => ({ ...prev, med_name: e.target.value }))} value={formData.med_name} className="form-control" placeholder="Enter Medicine name" type="text" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Select Category</label>
                  <div className="d-flex gap-2 align-items-center">
                    <div style={{ flex: 1 }}>
                      <CreatableSelect
                        isClearable
                        styles={rsStyles}
                        placeholder="Select or type to create..."
                        options={formData.cats}
                        value={findOption(formData.cats, formData.med_sel_category)}
                        onChange={handleSelectCategory}
                        onCreateOption={onCreateCategory}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                        menuPosition="fixed"
                      />
                    </div>
                    <div>
                      <button type="button" className="btn btn-outline-secondary" title="Add category" onClick={promptAddCategory}>+</button>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label">Select Unit</label>
                  <div className="d-flex gap-2 align-items-center">
                    <div style={{ flex: 1 }}>
                      <CreatableSelect
                        isClearable
                        styles={rsStyles}
                        placeholder="Select unit or type to create..."
                        options={formData.units}
                        value={findOption(formData.units, formData.med_select_unit)}
                        onChange={handleSelectUnit}
                        onCreateOption={onCreateUnit}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                        menuPosition="fixed"
                      />
                    </div>
                    <div>
                      <button type="button" className="btn btn-outline-secondary" title="Add unit" onClick={promptAddUnit}>+</button>
                    </div>
                  </div>
                </div>

                {/* the rest of your fields */}
                <div className="col-md-4">
                  <label className="form-label">Package Number</label>
                  <input name="med_pkg_number" onChange={(e) => setFormData(prev => ({ ...prev, med_pkg_number: e.target.value }))} value={formData.med_pkg_number} className="form-control" placeholder="Enter Package Number" type="text" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Hsn Code</label>
                  <input name="med_hsn_code" onChange={(e) => setFormData(prev => ({ ...prev, med_hsn_code: e.target.value }))} value={formData.med_hsn_code} className="form-control" placeholder="Enter Hsn Code" type="text" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Central Tax</label>
                  <input name="med_central_tax" onChange={(e) => { handleChange(e); }} value={formData.med_central_tax} className="form-control" placeholder="Enter Central Tax" type="number" step="0.01" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">State Tax</label>
                  <input name="med_state_tax" onChange={(e) => { handleChange(e); }} value={formData.med_state_tax} className="form-control" placeholder="Enter State Tax" type="number" step="0.01" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Integrated Tax</label>
                  <input name="med_comp_name" readOnly value={formData.med_comp_name} className="form-control" placeholder="Integrated Tax" type="text" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Medicine Composition</label>
                  <input name="med_composition" onChange={(e) => setFormData(prev => ({ ...prev, med_composition: e.target.value }))} value={formData.med_composition} className="form-control" placeholder="Enter Medicine Composition" type="text" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Medicine In Strips</label>
                  <input name="med_in_strips" onChange={(e) => setFormData(prev => ({ ...prev, med_in_strips: e.target.value }))} value={formData.med_in_strips} className="form-control" placeholder="Enter In Strips" type="text" />
                </div>

              </div>
            </div>

            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" id="closeBt45" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                {formData.med_id ? <button type="submit" className="btn btn-success" id="edit-btn">Update</button> : <button type="submit" className="btn btn-success" id="edit-btn">Add</button>}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMedicine;